import React from 'react';
import { Card } from 'antd';
import './page.css';

/** Page card: borderless antd Card; radius comes from the theme (no inline borderRadius). */
const DataCard = ({ className = '', ...rest }) => (
  <Card variant="borderless" className={`pl-datacard ${className}`.trim()} {...rest} />
);

export default DataCard;
